<template>
  <el-dialog
    title="检查费用"
    :visible.sync="isShow"
    :destroy-on-close="true"
    :close-on-click-modal="false"
    @close="closeDetail"
    width="1200px"
  >
    <CheckOutlayDetail :recordId="recordId" :active="active" @close="closeDetail" @success="formSaveSuccess"></CheckOutlayDetail>
  </el-dialog>
</template>

<script>
import CheckOutlayDetail from './CheckOutlayDetail'

export default {
  components: {
    CheckOutlayDetail
  },
  props: {
    active: String,
    dialogVisible: false,
    recordId: {
      type: String
    }
  },
  data () {
    return {
      isShow: this.dialogVisible
    }
  },
  watch: {
    dialogVisible() {
      this.isShow = this.dialogVisible;
      if (this.dialogVisible) {
        this.loadData()
      }
    },
    active (val) {
      this.localActive = val;
    }
  },
  methods: {
    closeDetail() {
      this.$emit("update:dialogVisible", false);
      this.$emit('close');
    },
    formSaveSuccess (outlay) {
      this.$emit('success', outlay)
    }
  },
};
</script>

<style lang="scss" scoped>
@import 'src/common/form.scss';
</style>


// WEBPACK FOOTER //
// src/pages/outlay/view/CheckOutlayDialog.vue